import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TitleStyled = styled.h3`
  font-size: 2.4rem;
  color: ${colors.neutral[900]};
  margin: 0 0 3rem;
  padding-bottom: 1.6rem;
  border-bottom: 0.1rem solid ${colors.neutral[300]};
`;

export const AnswersListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  padding: 0;
  list-style: none;
`;

export const ItemStyled = styled.li`
  display: flex;
  gap: 5rem;
  font-size: 1.8rem;
`;

export const ItemTitleStyled = styled.p`
  margin: 0;
  font-weight: 700;
  line-height: 2rem;
  min-width: 18rem;
  color: ${colors.neutral[700]};
`;

export const ItemValueStyled = styled.p`
  margin: 0;
  color: ${colors.neutral[900]};
`;
